import { createMuiTheme } from "@material-ui/core/styles";
import { blue, blueGrey } from "@material-ui/core/colors";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {}
  interface PaletteOptions {}
}

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: blue[800],
    },
    secondary: {
      main: blueGrey[500],
    },
  },
  typography: {
    h1: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h2: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h3: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h4: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h5: {
      fontWeight: 700,
      color: "#1e2022",
    },
    h6: {
      fontWeight: 400,
      color: "#1e2022",
    },
  },
});

theme.typography.h1 = {
  ...theme.typography.h1,
  fontSize: "3rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "3.50rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "4rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "6rem",
  },
};

theme.typography.h2 = {
  ...theme.typography.h2,
  fontSize: "2rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "2.50rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "3rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "3.75rem",
  },
};

theme.typography.h5 = {
  ...theme.typography.h5,
  fontSize: "1.1rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "1.3rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1.4rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "1.5rem",
  },
};

theme.typography.h6 = {
  ...theme.typography.h6,
  fontSize: "1.1rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "1.1rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1.15rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "1.25rem",
  },
};

theme.typography.body1 = {
  ...theme.typography.body1,
  fontSize: "1rem",
  [theme.breakpoints.up("sm")]: {
    fontSize: "1rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1.05rem",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "1.1rem",
  },
};



// WEBPACK FOOTER //
// ./src/utils/Theme.ts